<template>
  <div>
    <b-modal
      id="reasonFailGraduation"
      body-class="position-static"
      centered
      title="Danh sách các tiêu chí chưa đạt"
      no-close-on-backdrop
      size="xl"
      :hide-footer="true"
      @show="onShow"
      @hidden="onHide"
    >

      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col cols="12">
                <vue-good-table
                  :columns="columns"
                  :rows="subject"
                  :pagination-="paginationOptions"
                  :line-numbers="true"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'subjectId'">
                      {{ getSubjectName(props.row.subjectId) }}
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCol, BModal, BOverlay, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import api from './api'

export default {
  name: 'ReasonFailGraduation',
  directives: {
    Ripple,
  },
  components: {
    BModal,
    BCard,
    BCol,
    BOverlay,
    BRow,
    VueGoodTable,
  },
  props: {
    data: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 1000000,
        organizationId: getUser().orgId,
        departmentId: '',
        subjectTypeId: '',
        name: '',
        code: '',
        status: 1,
        sort: '',
      },
      user: getUser(),
      currentDataSource: undefined,
      currentScheduleCourse: undefined,
      paginationOptions: {
        enabled: false,
      },
      columns: [
        {
          label: 'Tiêu chí chưa đạt',
          field: 'subjectId',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'status',
          sortable: true,
          thClass: 'text-center',
        },
      ],
      subject: [],
      allSubject: [],
    }
  },
  methods: {
    async onShow() {
      if (this.data.subjectNotPass !== null) {
        const subjectNotPass = this.data.subjectNotPass.split(',').map(item => ({
          subjectId: Number(item),
          status: 'Học phần chưa đạt',
        }))
        subjectNotPass.forEach(item => {
          this.subject.push(item)
        })
      }
      if (this.data.preconditonSubjectNotPass !== null) {
        const conditionNotPass = this.data.preconditonSubjectNotPass.split(',').map(item => ({
          subjectId: Number(item),
          status: 'Học phần tiên quyết tốt nghiệp chưa đạt',
        }))
        conditionNotPass.forEach(item => {
          this.subject.push(item)
        })
      }
      this.isLoading = true
      try {
        this.allSubject = await api.getSubjects(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onHide() {
      this.subject = []
    },
    getSubjectName(id) {
      const found = this.allSubject.find(sub => sub.id === id)
      return found ? `${found.code} - ${found.name}` : ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table';
</style>
